import { TProducts, TVacancies } from './types';
import { pipe } from 'ramda';
import { sendCaEvent } from '../sendCaEvent';
import { TDeviceType } from '@cian/ui-kit';
import { getSiteType } from '../getSiteType';
import { TCaEventCreator, TCaEventDataSelector, TEventDataParser } from '../types';

type TEventExtra = TProducts;
type TEventData = TVacancies;

const createEvent: TCaEventCreator<TEventExtra, TEventData> = props => ({
  name: 'newpage',
  category: 'page',
  action: 'newpage',
  label: 'open',
  page: {
    pageType: 'CardVac',
    siteType: props.siteType,
  },
  products: props.vacancies,
});

type TRawData = {
  deviceType: TDeviceType;
  vacancyId: number;
};

const parseData: TEventDataParser<TRawData, TEventData> = rawData => ({
  vacancies: [{ id: rawData.vacancyId }],
  siteType: getSiteType(rawData.deviceType),
});

const selectData: TCaEventDataSelector<TRawData> = state => {
  return {
    vacancyId: state.vacancies.vacancy?.id as number,
    deviceType: state.page.deviceType,
  };
};

export const createOpenVacancyPageEvent = pipe(selectData, parseData, createEvent);

export const sendOpenVacancyPageEvent = pipe(createOpenVacancyPageEvent, sendCaEvent);
